import { useState, useEffect } from 'react'
import { ProfileImport } from './Import'
const { Form, Card, FormikProvider, useFormik, Text, Number, Email, File, SelectBox, SaveButton, UpdateProfileSchema, useNavigate, useDispatch, useSelector, updateProfile, departmentList, designationList, Loader, addUpdateHandler, toggleUpdateModal, toggleBool, useTranslation } = ProfileImport

export default function UpdateProfileForm() {

    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const details = useSelector(state => state?.profileDetails?.data)
    const department = useSelector(state => state?.departmentList?.data)
    const designation = useSelector(state => state?.designationList?.data)

    const department_option = department?.map(val => (
        { "value": val.id, "label": val.department_name }
    ))

    const designation_option = designation?.map(val => (
        { "value": val.id, "label": val.designation_name }
    ))

    const initialValues = {
        id: details?.id,
        name: details?.userDetails?.user_name || '',
        staffid: details?.userDetails?.user_code || '',
        mobile: details?.ul_user_mobile || '',
        email: details?.ul_user_email || '',
        department: details?.userDetails?.department_id || '',
        designation: details?.userDetails?.designation_id || '',
        profile: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: UpdateProfileSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            setSpinner(true)
            dispatch(updateProfile({ 'values': values })).then((res) => addUpdateHandler({
                res: res.payload,
                action,
                navigate,
                success_toast: `${t('profile.profile')} ${t('common.success_update')}`,
                wrong_toast: `${t('common.wrong')}`,
                navigate_route: '',
                spinner: setSpinner,
                toggle: () => {
                    dispatch(toggleUpdateModal());
                    dispatch(toggleBool());
                }
            }))
        },
    })

    useEffect(() => {
        setLoading(true)
        Promise.all([
            dispatch(departmentList({ navigate })),
            dispatch(designationList({ navigate }))
        ]).finally(() => setLoading(false));
    }, [])

    return (
        <>
            <div className="container-fluid">
                {loading ?
                    <div className="row">
                        <div className="col-md-12">
                            <Loader />
                        </div>
                    </div>
                    :
                    <FormikProvider value={formik}>
                        <Form onSubmit={(e) => { e.preventDefault(); formik.handleSubmit(); }}>
                            <div className="row g-3">

                                <div className="col-lg-12">
                                    <Card className='border-0 shadow-sm' style={{ borderRadius: '12px' }}>
                                        <Card.Body className='p-4'>
                                            <h5 className='mb-4 fw-bold' style={{ color: '#667eea' }}>
                                                {t('profile.personal_information')}
                                            </h5>
                                            <div className="row g-3">
                                                <div className="col-md-6">
                                                    <Text
                                                        label_name={t('profile.name')}
                                                        mandatory={true}
                                                        placeholder=''
                                                        disabled={false}
                                                        name='name'
                                                        value={formik.values.name}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.errors.name && formik.touched.name ? (<span className='field_error'>{formik.errors.name}</span>) : null}
                                                    />
                                                </div>

                                                <div className="col-md-6">
                                                    <Text
                                                        label_name={t('profile.staff_id')}
                                                        mandatory={true}
                                                        placeholder=''
                                                        disabled={false}
                                                        name='staffid'
                                                        value={formik.values.staffid}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.errors.staffid && formik.touched.staffid ? (<span className='field_error'>{formik.errors.staffid}</span>) : null}
                                                    />
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>

                                <div className="col-lg-12">
                                    <Card className='border-0 shadow-sm' style={{ borderRadius: '12px' }}>
                                        <Card.Body className='p-4'>
                                            <h5 className='mb-4 fw-bold' style={{ color: '#667eea' }}>
                                                {t('profile.contact_information')}
                                            </h5>
                                            <div className="row g-3">
                                                <div className="col-md-6">
                                                    <Email
                                                        label_name={t('profile.email')}
                                                        mandatory={true}
                                                        placeholder=''
                                                        disabled={false}
                                                        name='email'
                                                        value={formik.values.email}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.errors.email && formik.touched.email ? (<span className='field_error'>{formik.errors.email}</span>) : null}
                                                    />
                                                </div>

                                                <div className="col-md-6">
                                                    <Number
                                                        label_name={t('profile.mobile')}
                                                        mandatory={true}
                                                        placeholder=''
                                                        disabled={false}
                                                        name='mobile'
                                                        value={formik.values.mobile}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.errors.mobile && formik.touched.mobile ? (<span className='field_error'>{formik.errors.mobile}</span>) : null}
                                                    />
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>

                                <div className="col-lg-12">
                                    <Card className='border-0 shadow-sm' style={{ borderRadius: '12px' }}>
                                        <Card.Body className='p-4'>
                                            <h5 className='mb-4 fw-bold' style={{ color: '#667eea' }}>
                                                {t('profile.professional_information')}
                                            </h5>
                                            <div className="row g-3">
                                                <div className="col-md-6">
                                                    <SelectBox
                                                        label_name={t('profile.department')}
                                                        mandatory={true}
                                                        placeholder='Select Department'
                                                        disabled={false}
                                                        option={department_option}
                                                        name='department'
                                                        value={formik.values.department}
                                                        onChange={(e) =>
                                                            formik.setFieldValue('department', e)
                                                        }
                                                        onBlur={() => formik.setFieldTouched("department", true)}
                                                        filterOption={(input, option) =>
                                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                        }
                                                        error={formik.errors.department && formik.touched.department ? (<span className='field_error'>{formik.errors.department}</span>) : null}
                                                    />
                                                </div>

                                                <div className="col-md-6">
                                                    <SelectBox
                                                        label_name={t('profile.designation')}
                                                        mandatory={true}
                                                        placeholder='Select Designation'
                                                        disabled={false}
                                                        option={designation_option}
                                                        name='designation'
                                                        value={formik.values.designation}
                                                        onChange={(e) =>
                                                            formik.setFieldValue('designation', e)
                                                        }
                                                        onBlur={() => formik.setFieldTouched("designation", true)}
                                                        filterOption={(input, option) =>
                                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                        }
                                                        error={formik.errors.designation && formik.touched.designation ? (<span className='field_error'>{formik.errors.designation}</span>) : null}
                                                    />
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>

                                <div className="col-lg-12">
                                    <Card className='border-0 shadow-sm' style={{ borderRadius: '12px' }}>
                                        <Card.Body className='p-4'>
                                            <h5 className='mb-4 fw-bold' style={{ color: '#667eea' }}>
                                                {t('profile.profile_photo')}
                                            </h5>
                                            <div className="row g-3">
                                                <div className="col-md-6">
                                                    <File
                                                        label_name={t('profile.profile')}
                                                        mandatory={false}
                                                        disabled={false}
                                                        name='profile'
                                                        onChange={(e) =>
                                                            formik.setFieldValue('profile', e.currentTarget.files[0])
                                                        }
                                                        onBlur={formik.handleBlur}
                                                        error={formik.errors.profile && formik.touched.profile ? (<span className='field_error'>{formik.errors.profile}</span>) : null}
                                                        accept="image/jpg, image/jpeg, image/png"
                                                    />
                                                    <small className="text-muted" style={{ fontSize: '12px' }}>
                                                        Accepted formats: JPG, JPEG, PNG
                                                    </small>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>

                                <div className="col-lg-12">
                                    <div className="d-flex justify-content-end">
                                        <div className="col-lg-3">
                                            <SaveButton
                                                button_name={t('common.submit')}
                                                spinner={spinner}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </FormikProvider>
                }
            </div>
        </>
    )
}